import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignature, faTimes } from '@fortawesome/free-solid-svg-icons';
import DefaultCPButton from './defaultCommandPanelButton';

function UnExecuteButton({ content, onClick, disabled }) {
  return (
    <DefaultCPButton
      content={content}
      onClick={onClick}
      disabled={disabled}
      icon={(
        <span className="fa-layers fa-fw">
          <FontAwesomeIcon icon={faSignature} />
          <FontAwesomeIcon
            icon={faTimes}
            size="xs"
            color="red"
            pull="right"
            transform="shrink-2 right-10 down-7"
          />
        </span>
      )}
      color="warning"
    />
  );
}

UnExecuteButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

UnExecuteButton.defaultProps = {
  content: 'Відмінити проведення',
  disabled: false,
};

export default UnExecuteButton;
